import type { CSSProperties, ElementType, ReactNode } from 'react';
import { Accordion } from 'react-bootstrap';

export type BaseAccordionProps = {
  eventKey?: string | number;
  header?: ReactNode;
  headerActions?: ReactNode;
  bodyBackground?: string;
  children?: ReactNode;
  rounded?: boolean;
  headingLevel?: ElementType;
} & {};

/**
 * Shared accordion wrapper used across the app.
 */
const BaseAccordion = ({
  eventKey = 0,
  header = '',
  headerActions,
  bodyBackground = '',
  children,
  rounded = true,
  headingLevel = 'h2',
}: BaseAccordionProps): JSX.Element => {
  const accordionStyle = rounded ? { borderRadius: '16px', overflow: 'hidden' } : undefined;
  const itemStyle = rounded ? { borderRadius: '16px', overflow: 'hidden' } : undefined;
  const resolvedEventKey = String(eventKey);

  return (
    <Accordion className="border-0" style={accordionStyle}>
      <Accordion.Item eventKey={resolvedEventKey} style={itemStyle}>
        {headerActions ? (
          <div className="d-flex flex-wrap align-items-center">
            <Accordion.Header as={headingLevel} className="flex-grow-1 min-w-0">
              {header}
            </Accordion.Header>
            {headerActions}
          </div>
        ) : (
          <Accordion.Header as={headingLevel}>{header}</Accordion.Header>
        )}
        <Accordion.Body
          className="w-100 h-100"
          style={{ ['--accordion-body-bg' as string]: bodyBackground } as CSSProperties}
        >
          {children}
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default BaseAccordion;
